import { Animal, CountryCode, Listing, Paginator } from 'shared/@types';
import { RequestClient } from 'shared/library/api-client';
import { getSafeLanguageCode } from 'shared/library/i18n/languages';
import { marketByLanguageCode } from 'shared/library/i18n/market';
import { apiRoute } from 'shared/library/api-route';

const LISTING_PREVIEW_SIZE = 8;

type BuyingADogPageContext = {
  locale?: string;
  countryCode?: CountryCode;
};

function resolveBuyingADogCountry(ctx: BuyingADogPageContext): CountryCode {
  const languageCode = getSafeLanguageCode(ctx.locale);

  return ctx.countryCode ?? marketByLanguageCode(languageCode)?.country_code ?? 'SE';
}

async function loadBuyingADogListings(req: RequestClient, ctx: BuyingADogPageContext) {
  const listingCountry = resolveBuyingADogCountry(ctx);
  const [localResponse, swedishResponse] = await Promise.all([
    req<{ listings: Paginator<Listing> }>(apiRoute('listings.index'), {
      format: 'card',
      animal: Animal.Dog,
      country: listingCountry,
      per_page: LISTING_PREVIEW_SIZE,
    }),
    listingCountry === 'SE'
      ? Promise.resolve(null)
      : req<{ listings: Paginator<Listing> }>(apiRoute('listings.index'), {
          format: 'card',
          animal: Animal.Dog,
          country: 'SE',
          per_page: LISTING_PREVIEW_SIZE,
        }).catch(() => null),
  ]);
  const swedishSlots = Math.max(0, LISTING_PREVIEW_SIZE - localResponse.listings.data.length);
  const swedishListings = swedishResponse?.listings.data.slice(0, swedishSlots) ?? [];

  return {
    listings: {
      ...localResponse.listings,
      data: [...localResponse.listings.data, ...swedishListings],
    },
    listingCountry,
  };
}

export { loadBuyingADogListings, resolveBuyingADogCountry };
